import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e9290870")

_pushScopeId("data-v-e9290870")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("h4", null, "Por favor inicia sesión", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "position-relative"
}, [
  /*#__PURE__*/_createVNode("symbol", {
    id: "checkmark-bold",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", { d: "M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" })
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")
  const _component_router_view = _resolveComponent("router-view")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    (_ctx.sesionIniciada)
      ? (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.fullPath
        }))
      : _createCommentVNode("", true),
    (!_ctx.sesionIniciada)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.regresarLogin && _ctx.regresarLogin(...args))),
            class: "btn bg-primary text-white"
          }, "Iniciar Sesión")
        ]))
      : _createCommentVNode("", true),
    _hoisted_4,
    _createVNode(_component_Footer)
  ]))
})